import * as stores from './localStoreActionTypes';

const initialState = {
    supplierTypes: [],
    suppliers: [],
    purchaseOrders: [],
    productGroups: [],
    products: [],
    unitOfMeasurements: [],
    purchaseOrderTypes: [],
    paymentTerms: [],
    transportTypes: [],
    currencies: [],
    languages: [],
    translationValues: [],
    translations: [],
    translationTypes: [],
    systemTranslations: [],
    systemTranslationValues: [],
    systemParameters: [],
    systemParameterValues: [],
    countries: [],
    numberRanges: [],
    documentTextOverview: [],
    brokers: [],
    documents: [],
    documentTypes: [],
    purchaseOrderDocuments: [],
    priceSchemes: [],
    freeClauses: [],
};

export default function localStore(state = initialState, store) {
    switch (store.type) {
        case stores.SUPPLIERTYPES_STORE:
            //console.log('Updating store: ' + stores.SUPPLIERTYPES_STORE);
            return Object.assign({}, state, { supplierTypes: store.data })

        case stores.SUPPLIERS_STORE:
            //console.log('Updating store: ' + stores.SUPPLIERS_STORE);
            return Object.assign({}, state, { suppliers: store.data })

        case stores.PURCHASEORDERS_STORE:
            //console.log('Updating store: ' + stores.PURCHASEORDERS_STORE);
            return Object.assign({}, state, { purchaseOrders: [...state.purchaseOrders, store.data] })

        case stores.PRODUCTGROUPS_STORE:
            //console.log('Updating store: ' + stores.PRODUCTGROUPS_STORE);
            return Object.assign({}, state, { productGroups: store.data })

        case stores.PRODUCTS_STORE:
            //console.log('Updating store: ' + stores.PRODUCTS_STORE);
            return Object.assign({}, state, { products: store.data })

        case stores.UNITOFMEASUREMENTS_STORE:
            //console.log('Updating store: ' + stores.UNITOFMEASUREMENTS_STORE);
            return Object.assign({}, state, { unitOfMeasurements: store.data })

        case stores.PURCHASEORDERTYPES_STORE:
            //console.log('Updating store: ' + stores.PURCHASEORDERTYPES_STORE);
            return Object.assign({}, state, { purchaseOrderTypes: store.data })

        case stores.PAYMENTTERMS_STORE:
            //console.log('Updating store: ' + stores.PAYMENTTERMS_STORE);
            return Object.assign({}, state, { paymentTerms: store.data })

        case stores.TRANSPORTTYPES_STORE:
            //console.log('Updating store: ' + stores.TRANSPORTTYPES_STORE);
            return Object.assign({}, state, { transportTypes: store.data })

        case stores.CURRENCIES_STORE:
            //console.log('Updating store: ' + stores.CURRENCIES_STORE);
            return Object.assign({}, state, { currencies: store.data })

        case stores.LANGUAGES_STORE:
            //console.log('Updating store: ' + stores.LANGUAGES_STORE);
            return Object.assign({}, state, { languages: store.data })

        case stores.TRANSLATIONVALUES_STORE:
            //console.log('Updating store: ' + stores.TRANSLATIONVALUES_STORE);
            return Object.assign({}, state, { translationValues: store.data })

        case stores.TRANSLATIONS_STORE:
            //console.log('Updating store: ' + stores.TRANSLATIONS_STORE);
            return Object.assign({}, state, { translations: store.data })

        case stores.TRANSLATIONTYPES_STORE:
            //console.log('Updating store: ' + stores.TRANSLATIONTYPES_STORE);
            return Object.assign({}, state, { translationTypes: store.data })

        case stores.SYSTEMTRANSLATIONS_STORE:
            //console.log('Updating store: ' + stores.SYSTEMTRANSLATIONS_STORE);
            return Object.assign({}, state, { systemTranslations: store.data })

        case stores.SYSTEMTRANSLATIONVALUES_STORE:
            //console.log('Updating store: ' + stores.SYSTEMTRANSLATIONVALUES_STORE);
            return Object.assign({}, state, { systemTranslationValues: store.data })

        case stores.SYSTEMPARAMETERS_STORE:
            //console.log('Updating store: ' + stores.SYSTEMPARAMETERS_STORE);
            return Object.assign({}, state, { systemParameters: store.data })

        case stores.SYSTEMPARAMETERVALUES_STORE:
            //console.log('Updating store: ' + stores.SYSTEMPARAMETERVALUES_STORE);
            return Object.assign({}, state, { systemParameterValues: store.data })

        case stores.COUNTRIES_STORE:
            //console.log('Updating store: ' + stores.COUNTRIES_STORE);
            return Object.assign({}, state, { countries: store.data })

        case stores.NUMBERRANGES_STORE:
            //console.log('Updating store: ' + stores.NUMBERRANGES_STORE);
            return Object.assign({}, state, { numberRanges: store.data })

        case stores.DOCUMENTTEXTOVERVIEW_STORE:
            //console.log('Updating store: ' + stores.DOCUMENTTEXTOVERVIEW_STORE);
            return Object.assign({}, state, { documentTextOverview: store.data })

        case stores.BROKERS_STORE:
            //console.log('Updating store: ' + stores.BROKERS_STORE);
            return Object.assign({}, state, { brokers: store.data })

        case stores.DOCUMENTS_STORE:
            //console.log('Updating store: ' + stores.DOCUMENTS_STORE);
            return Object.assign({}, state, { documents: store.data })

        case stores.DOCUMENTTYPES_STORE:
            //console.log('Updating store: ' + stores.DOCUMENTTYPES_STORE);
            return Object.assign({}, state, { documents: store.data })

        case stores.PURCHASEORDERDOCUMENTS_STORE:
            //console.log('Updating store: ' + stores.PURCHASEORDERDOCUMENTS_STORE);
            return Object.assign({}, state, { purchaseOrderDocuments: store.data })

        case stores.UPDATEPURCHASEORDER:
            var array = [...state.purchaseOrders];

            var index = array.map(x => {
                return x.externalReferenceID;
            }).indexOf(store.data.externalReferenceID);

            array.splice(index, 1, store.data)

            if (state.purchaseOrderLines !== array) {
                return Object.assign({}, state, { purchaseOrders: array });
            }

        case stores.PRICESCHEMES_STORE:
            //console.log('Updating store: ' + stores.PURCHASEORDERDOCUMENTS_STORE);
            return Object.assign({}, state, { priceSchemes: store.data })

        case stores.FREECLAUSES_STORE:
            //console.log('Updating store: ' + stores.FREECLAUSES_STORE);
            return Object.assign({}, state, { freeClauses: store.data })

        default:
            return state;
    }
}

//FREECLAUSES_STORE